export default function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <g clipPath="url(#clip0_11388_24726)">
        <path
          d="M17.6018 3.16662C17.6018 4.58765 16.45 5.73963 15.0289 5.73963C13.6079 5.73963 12.4561 4.58765 12.4561 3.16662C12.4561 1.74574 13.6079 0.59375 15.0289 0.59375C16.45 0.59375 17.6018 1.74574 17.6018 3.16662Z"
          fill="currentColor"
        />
        <path
          d="M15.0289 6.33338C13.2825 6.33338 11.8623 4.91308 11.8623 3.16662C11.8623 1.4203 13.2825 0 15.0289 0C16.7754 0 18.1955 1.4203 18.1955 3.16662C18.1955 4.91308 16.7754 6.33338 15.0289 6.33338ZM15.0289 1.1875C13.9372 1.1875 13.0498 2.07581 13.0498 3.16662C13.0498 4.25758 13.9372 5.14588 15.0289 5.14588C16.1206 5.14588 17.008 4.25758 17.008 3.16662C17.008 2.07581 16.1206 1.1875 15.0289 1.1875Z"
          fill="currentColor"
        />
        <path
          d="M17.6018 15.8333C17.6018 17.2542 16.45 18.4061 15.0289 18.4061C13.6079 18.4061 12.4561 17.2542 12.4561 15.8333C12.4561 14.4122 13.6079 13.2603 15.0289 13.2603C16.45 13.2603 17.6018 14.4122 17.6018 15.8333Z"
          fill="currentColor"
        />
        <path
          d="M15.0289 18.9999C13.2825 18.9999 11.8623 17.5796 11.8623 15.8333C11.8623 14.0868 13.2825 12.6665 15.0289 12.6665C16.7754 12.6665 18.1955 14.0868 18.1955 15.8333C18.1955 17.5796 16.7754 18.9999 15.0289 18.9999ZM15.0289 13.854C13.9372 13.854 13.0498 14.7423 13.0498 15.8333C13.0498 16.9241 13.9372 17.8124 15.0289 17.8124C16.1206 17.8124 17.008 16.9241 17.008 15.8333C17.008 14.7423 16.1206 13.854 15.0289 13.854Z"
          fill="currentColor"
        />
        <path
          d="M6.51893 9.50011C6.51893 10.9211 5.36694 12.073 3.94592 12.073C2.52503 12.073 1.37305 10.9211 1.37305 9.50011C1.37305 8.07909 2.52503 6.92725 3.94592 6.92725C5.36694 6.92725 6.51893 8.07909 6.51893 9.50011Z"
          fill="currentColor"
        />
        <path
          d="M3.94592 12.6667C2.1996 12.6667 0.779297 11.2466 0.779297 9.50011C0.779297 7.75365 2.1996 6.3335 3.94592 6.3335C5.69238 6.3335 7.11268 7.75365 7.11268 9.50011C7.11268 11.2466 5.69238 12.6667 3.94592 12.6667ZM3.94592 7.521C2.85423 7.521 1.9668 8.40916 1.9668 9.50011C1.9668 10.5911 2.85423 11.4792 3.94592 11.4792C5.03774 11.4792 5.92518 10.5911 5.92518 9.50011C5.92518 8.40916 5.03774 7.521 3.94592 7.521Z"
          fill="currentColor"
        />
        <path
          d="M5.81492 9.11991C5.53935 9.11991 5.27176 8.97655 5.12607 8.72012C4.90994 8.3409 5.04301 7.85718 5.42222 7.64018L12.768 3.45232C13.1472 3.2346 13.6309 3.36767 13.8479 3.74833C14.0641 4.12754 13.931 4.61127 13.5518 4.82827L6.20587 9.01612C6.08237 9.08657 5.94784 9.11991 5.81492 9.11991Z"
          fill="currentColor"
        />
        <path
          d="M13.1601 15.6515C13.027 15.6515 12.8925 15.6182 12.769 15.5477L5.42309 11.3599C5.04388 11.1437 4.91095 10.66 5.12709 10.2799C5.34235 9.89998 5.8268 9.76618 6.20688 9.98391L13.5528 14.1718C13.932 14.3879 14.0649 14.8716 13.8488 15.2517C13.7024 15.5081 13.4348 15.6515 13.1601 15.6515Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11388_24726">
          <rect width="19" height="19" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
